/** A meeting's saved timezone is authoritative; older records use the viewer's preference. */
export function resolveMeetingTimeZone(meetingTimeZone?: string | null, viewerTimeZone?: string | null): string {
  for (const candidate of [meetingTimeZone, viewerTimeZone, Intl.DateTimeFormat().resolvedOptions().timeZone, 'UTC']) {
    if (!candidate) continue
    try { new Intl.DateTimeFormat('en-US', { timeZone: candidate }).format(); return candidate } catch { /* Try the next supported zone. */ }
  }
  return 'UTC'
}

export function meetingTimeZoneLabel(instant: Date, timeZone: string): string {
  return new Intl.DateTimeFormat('en-US', { timeZone, timeZoneName: 'short' }).formatToParts(instant).find(part => part.type === 'timeZoneName')?.value || timeZone
}

export function meetingDateKey(instant: Date, timeZone: string): string {
  const parts = new Intl.DateTimeFormat('en-US', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(instant)
  return ['year', 'month', 'day'].map(type => parts.find(part => part.type === type)?.value).join('-')
}
